var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.brand == 'WBET')?_c('newbet'):(_vm.brand == 'BT')?_c('ubett'):(_vm.brand == 'IBCBET')?_c('ibcbet'):_c('sportsbook')
}
var staticRenderFns = []

export { render, staticRenderFns }